<template>
  <header>
    <div class="topbar">
      <div class="nav">
        <div class="lf">
          <template v-if="userInfo.username">
            <router-link :to="backUrl"
              >您好，{{ userInfo.username }}</router-link
            >
            <el-divider direction="vertical"></el-divider>
            <a href="javascript:void(0);" @click="handleLogout">退出登录</a>
          </template>
          <template v-else>
            <a href="javascript:void(0);">欢迎来到默默通智慧物流平台</a>
            <el-divider direction="vertical"></el-divider>
            <router-link to="/user/login">请登录</router-link>
            <el-divider direction="vertical"></el-divider>
            <router-link to="/user/register">免费注册</router-link>
            <el-divider direction="vertical"></el-divider>
            <router-link to="/user/reset">忘记密码</router-link>
          </template>
        </div>
        <div class="rg">
          <router-link to="/">默默通首页</router-link>
          <el-divider direction="vertical"></el-divider>
          <router-link :to="backUrl">个人中心</router-link>
          <el-divider direction="vertical"></el-divider>
          <a href="http://www.gzmsteel.com" target="_blank">钢之梦</a>
          <el-divider direction="vertical"></el-divider>
          <a href="https://www.hongyiding.com" target="_blank">小梦料理</a>
          <el-divider direction="vertical"></el-divider>
          <a href="javascript:void(0);" @click="handleDownClick">APP下载</a>
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="menu_wrap">
        <div class="lf">
          <div class="logo_wrap">
            <router-link to="/">
              <img src="@/assets/logo.png" alt="" />
            </router-link>
          </div>
          <div class="meun_list">
            <router-link to="/" exact-active-class="active">首页</router-link>
            <router-link
              to="/gdlist"
              :class="{
                active:
                  $route.path === '/gdlist' ||
                  $route.path.indexOf('/gddetail') > -1,
              }"
              >货源中心</router-link
            >
            <router-link
              to="/tklist"
              :class="{
                active:
                  $route.path === '/tklist' ||
                  $route.path.indexOf('/tkdetail') > -1,
              }"
              >车源中心</router-link
            >
            <router-link to="/news" exact-active-class="active"
              >资讯</router-link
            >
            <router-link to="/about" exact-active-class="active"
              >关于我们</router-link
            >
          </div>
        </div>
        <div class="rg">
          <div class="dh">客服电话</div>
          <div class="number">400-600-9716</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      role: state => state.user.role
    }),
    backUrl () {
      const roles = ['WLSJ', 'SJZJ', 'CCGJ', 'HZDJ', 'YYPLAT', 'JJXT', 'MMTPT']
      return this.userInfo.username ? (roles.indexOf(this.role) > -1 ? '/memberindex' : '/viraccountset/myrzmgr') : '/user/login'
    }
  },
  methods: {
    ...mapActions(['logout']),
    handleLogout () {
      if (this.$route.meta && this.$route.meta.authorities === 'login') {
        this.$router.push('/').catch(() => {})
      }
      this.logout()
    },
    handleDownClick () {
      const ele = document.getElementById('app_ercode')
      ele.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/_variables";
.topbar {
  border-bottom: 1px solid #eaecef;

  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1190px;
    height: 30px;
    margin: 0 auto;
    font-size: 12px;

    a {
      text-decoration: none;
      color: #606266;
      transition: all 0.2s ease-in-out;

      &:hover {
        color: $--color-primary;
      }
    }
  }
}

.menu {
  border-bottom: 2px solid $--color-primary;

  .menu_wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1190px;
    height: 60px;
    margin: 0 auto;

    .lf {
      display: flex;

      .logo_wrap {
        margin-right: 30px;

        img {
          display: block;
          height: 40px;
        }
      }

      .meun_list {
        display: flex;
        align-items: center;

        a {
          padding: 10px 30px;
          font-size: 16px;
          color: #606266;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.2s ease-in-out;

          &:hover {
            color: $--color-primary;
          }

          &.active {
            color: $--color-primary;
          }
        }
      }
    }

    .rg {
      display: flex;
      align-items: center;

      .dh {
        color: #606266;
        font-size: 14px;
      }

      .number {
        font-size: 16px;
        font-weight: 500;
        margin-left: 10px;
        color: $--color-primary;
      }
    }
  }
}
</style>
